import { RouteRecordRaw } from 'vue-router';

const timesheetRoutes: Array<RouteRecordRaw> = [
  {
    path: 'timesheet',
    component: () =>
      import('@/app/timesheet/components/timesheet-component.vue'),
    name: 'app.timesheet',
  },
];

export default timesheetRoutes;
